// Forms Input Mask

import "inputmask/dist/jquery.inputmask.bundle.js";

$(document).ready(() => {

    $(".input-mask-trigger").inputmask();
});